import {
  ApiErrorResponse,
  getDayjs,
  InputDataDetailsType,
  SampleCommentType,
  SubmittedDataVersionType,
} from '@atlas-frontend/sdk';
import { useInputDataDetailsStoreValue } from '../InputDataDetailsContext';
import { useMemo } from 'react';
import { useInputDetailsError } from '../inputErrorUtil';

export function useInputDataComments(
  inputDataDetailsType?: InputDataDetailsType,
  selectedVersion?: SubmittedDataVersionType,
  detailsError?: ApiErrorResponse | null,
) {
  const [segment] = useInputDataDetailsStoreValue('segment');
  const [commentsTotal] = useInputDataDetailsStoreValue('commentsTotal');

  const inputComment = useMemo(() => {
    const sampleComments = inputDataDetailsType?.sampleComments ?? [];

    let selectedComments: SampleCommentType[] = sampleComments.filter(
      (comment) =>
        comment.sampleDataObjectDescriptionId ===
        selectedVersion?.descriptionId,
    );

    if (selectedComments.length === 0) {
      return undefined;
    }

    const lastComment = selectedComments.reduce(
      (acc: SampleCommentType | undefined, comment) =>
        getDayjs(acc?.modifiedAt)?.isAfter(getDayjs(comment.modifiedAt))
          ? acc
          : comment,
      undefined,
    );

    return {
      ...lastComment,
      modifiedBy: lastComment?.modifiedBy?.id,
      modifiedUsername: lastComment?.modifiedBy?.username,
    };
  }, [inputDataDetailsType?.sampleComments, selectedVersion?.descriptionId]);

  const dataLoadingError = useInputDetailsError(detailsError);
  return { segment, commentsTotal, inputComment, dataLoadingError };
}
